export const INAV_VARIANTS = {
  CONTROL: 'control',
  INAV_VAR_A: 'variantA',
};

export const GLOBAL_HEADER_NAME = 'axp-global-header';

export const E1 = 'E1';
export const E2 = 'E2';
export const E3 = 'production';
